// extracted by mini-css-extract-plugin
export var label = "_d3-1";
export var reminder = "_d3-0";